import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=26160ecb&scoped=true"
import script from "@/components/Breadcrumbs/Divider.ts?vue&type=script&lang=ts&external"
export * from "@/components/Breadcrumbs/Divider.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/Breadcrumbs/divider.scss?vue&type=style&index=0&id=26160ecb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26160ecb",
  null
  
)

export default component.exports